import { render } from "./MultiButton.vue?vue&type=template&id=4543d8ac&scoped=true"
import script from "./MultiButton.vue?vue&type=script&lang=js"
export * from "./MultiButton.vue?vue&type=script&lang=js"

import "./MultiButton.vue?vue&type=style&index=0&id=4543d8ac&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4543d8ac"]])

export default __exports__